import axios from "@/libs/api.request";
// 获取列表
export const getExceptionTracker = params => {
  return axios.request({
    url: "/tracker/ExceptionTypes",
    method: "get",
    params
  });
};

export const getDetails = id => {
  return axios.request({
    url: `/tracker/ExceptionTypes/${id}`,
    method: "get"
  });
};

export const add = data => {
  return axios.request({
    url: "/tracker/ExceptionTypes",
    method: "post",
    data
  });
};

export const update = data => {
  return axios.request({
    url: `/tracker/ExceptionTypes/${data.id}`,
    method: "put",
    data
  });
};
export const del = id => {
  return axios.request({
    url: `/tracker/ExceptionTypes/${id}`,
    method: "delete"
  });
};

export const getTurns = () => {
  return axios.request({
    url: `/tracker/exception/turns`,
    method: "get"
  });
};

// 获取轨迹异常代理列表
export const getExceptionProxy = params => {
  return axios.request({
    url: "/tracker/agentTrace/getRegularAgents",
    method: "get",
    params
  });
};
